module.exports = __webpack_public_path__ + "static/media/CTLA_4-540w.f9c3a9f7.jpg";